import currencyCodes from 'currency-codes';

import getCountryByGeoLocation from './getCountryByGeoLocation';

/**
 * @deprecated TODO: Migrate to standardized geo-lookup service
 *
 * ISSUES:
 * 1. Relies on bundled JSON file (ne_110m_admin_0_countries.json) which is a maintenance risk
 * 2. No validation that returned currency is in our supported set
 * 3. Geo-location logic should be centralized in a dedicated service
 * 4. Should return Currency enum, not string
 *
 * MIGRATION PLAN:
 * - Create dedicated geo-location service/library
 * - Use external API or maintained geo-data package
 * - Add proper error handling and fallbacks
 * - Integrate with domains-billing-currency for type safety
 */
export default function getCurrencyByGeoLocation({
  latitude,
  longitude,
}: {
  latitude?: number;
  longitude?: number;
}): string {
  if (latitude == null || longitude == null) {
    return 'USD';
  }

  const country = getCountryByGeoLocation({ latitude, longitude });

  if (!country || !country.iso_n3) {
    return 'USD';
  }

  const currency = currencyCodes.number(country.iso_n3);

  return currency?.code ?? 'USD';
}
